const provinces = [
    "آذربايجان شرقي",
    "آذربايجان غربي",
    "اردبيل",
    "اصفهان",
    "البرز",
    "ايلام",
    "بوشهر",
    "تهران",
    "چهارمحال وبختياري",
    "خراسان جنوبي",
    "خراسان رضوي",
    "خراسان شمالي",
    "خوزستان",
    "زنجان",
    "سمنان",
    "سيستان و بلوچستان",
    "فارس",
    "قزوين",
    "قم",
    "كردستان",
    "كرمان",
    "كرمانشاه",
    "كهگيلويه و بويراحمد",
    "گلستان",
    "گيلان",
    "لرستان",
    "مازندران",
    "مركزي",
    "هرمزگان",
    "همدان",
    "يزد"
  ];
  
  export default provinces;
  